<template>
  <div>
    <div class="d-flex justify-content-between mb-1">
      <b-button
        v-b-toggle.questionFilter
        variant="outline-primary"
      >
        {{ t('Filters') }}
      </b-button>

      <b-button
        v-if="checkPermission(constants.ADD_TEMPLATE_QUESTION)"
        variant="primary"
        @click="$bvModal.show('createQuesitonModal')"
      >
        <feather-icon icon="PlusIcon" />
        {{ t('Add Question') }}
      </b-button>
    </div>
    <b-collapse
      id="questionFilter"
      class="mt-2"
    >
      <QuesitonFilter
        :form="filterForm"
        @refresTemplateList="refresTemplateList"
      />
    </b-collapse>
    <!-- Questions List Table -->

    <b-card>
      <b-table
        sticky-header
        responsive="true"
        :items="items.data"
        :fields="userFields"
        @row-contextmenu="contextmenu"
        @sort-changed="sortChanged"
      >
        <template #cell(status)="data">
          <span
            v-if="data.item.status === constants.USER_STATUS_ACTIVE"
            class="text-success cursor-pointer"
            @click="changeStatus(data.item.status, data.item.question_master_id )"
          >Active</span>
          <span
            v-if="data.item.status === constants.USER_STATUS_INACTIVE"
            class="text-danger cursor-pointer"
            @click="changeStatus(data.item.status, data.item.question_master_id )"
          >In-Active</span>
        </template>
        <!-- <template #cell(created_at)="data">
          {{ dateRegFormat(data.item.created_at) }}
        </template>
        <template #cell(updated_at)="data">
          {{ dateRegFormat(data.item.updated_at) }}
        </template> -->
        <template
          v-if="items.total == 0"
          #table-caption
        >
          <div
            class="text-center"
          >
            {{ t('No Record Found') }}
          </div>
        </template>
      </b-table>
      <b-row v-if="items.total">
        <b-col
          cols="4"
          class="d-flex"
        >
          <div class="align-self-center pr-2">
            {{ t('Total Entries') + " " + items.total }}
          </div>
          <b-form-group class="align-self-center mb-0">
            <label class="d-inline-block text-sm-left mr-50">{{ t('Per page') }}</label>
            <b-form-select
              id="perPageSelect"
              v-model="filterForm.size"
              size="sm"
              :options="tableFilter.pageOptions"
              class="w-70"
              @change="getQuestionList"
            />
          </b-form-group>

        </b-col>
        <b-col cols="8">
          <pagination
            :data="items"
            :limit="2"
            class="pt-1 justify-content-end"
            @pagination-change-page="getResults"
          />
        </b-col>

      </b-row>
    </b-card>

    <vue-context
      ref="templateContextMenu"
    >
      <li
        v-for="data in menuData"
        :key="data.text"
      >
        <b-link
          class="d-flex align-items-center"
          @click="optionClicked(data.id)"
        >
          <feather-icon
            :icon="data.icon"
            size="16"
          />
          <span class="ml-75">{{ data.text }}</span>
        </b-link>
      </li>
    </vue-context>

    <CreateQuestionModal :editques="valuesContext" />
  </div>
</template>

<script>
import 'bootstrap-vue'
import { useUtils } from '@core/libs/i18n'
import VueContext from 'vue-context'
import axios from '@/utils/axiosCompany'
import CreateQuestionModal from './CreateQuestionModal.vue'
import QuesitonFilter from './QuestionFilter.vue'
import { hideLoader, showLoader, tableFilter } from '@/utils/common'
import checkPermissions from '@/utils/checkPermissons'
import store from '@/store'
import constants from '@/constants'

export default {
  components: {
    CreateQuestionModal,
    VueContext,
    QuesitonFilter,
  },
  data() {
    return {
      constants,
      tableFilter,
      items: [],
      valuesContext: {},
      menuData: [],
      filterForm: {
        params: {
          template_id: '',
          template_name: '',
          service_id: '',
          status: '',
          period: '',
          start_date: '',
          end_date: '',
        },
        sortBy: 'id',
        sortOrder: 'desc',
        size: '10',
        pageNumber: '',
      },
    }
  },
  computed: {
    userFields() {
      return [
        { key: 'id', label: this.$i18n.t('Id'), sortable: true },
        { key: 'question', label: this.$i18n.t('Question'), sortable: true },
        { key: 'template_name', label: this.$i18n.t('Template Name'), sortable: true },
        { key: 'template_service_name', label: this.$i18n.t('Service Name'), sortable: true },
        { key: 'status', label: this.$i18n.t('Status'), sortable: true },
        { key: 'created', label: this.$i18n.t('Created By'), sortable: false },
      ]
    },
    menuOptions() {
      return [
        { id: 1, icon: 'EditIcon', text: this.$i18n.t('Edit Question') },
        // { id: 2, icon: 'PlusIcon', text: this.$i18n.t('Add Question') },
      ]
    },
  },
  watch: {
    $route(to, from) {
      if (to.name !== from.name) {
        this.filterForm.params.template_id = ''
        this.getQuestionList()
      }
    },
  },
  setup() {
    const { t } = useUtils()
    return {
      t,
    }
  },
  mounted() {
    this.$root.$on('refreshQuestionList', () => {
      this.getQuestionList()
    })
    this.$root.$on('bv::modal::hidden', (a, componentId) => {
      if (componentId === 'createQuesitonModal') {
        this.valuesContext = {}
      }
    })
  },
  methods: {
    checkPermission(val) {
      return checkPermissions(val)
    },
    sortChanged(val) {
      this.filterForm.sortBy = val.sortBy
      this.filterForm.sortOrder = val.sortDesc ? 'desc' : 'asc'
      this.getQuestionList()
    },
    refresTemplateList() {
      this.getQuestionList()
    },
    async getQuestionList() {
      if (this.$route.params.id) {
        this.filterForm.params.template_id = this.$route.params.id
      }
      showLoader()
      await store.dispatch('questionsStore/getQuestionList', this.filterForm).then(response => {
        if (response.data.code === constants.SUCCESS) {
          this.items = response.data.data
          hideLoader()
        }
      })
      hideLoader()
    },
    async getResults(page = 1) {
      showLoader()
      // eslint-disable-next-line no-undef
      await axios.post(`/template/get-question?page=${page}`, this.filterForm, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      })
        .then(response => {
          this.items = response.data.data
          hideLoader()
        })
      hideLoader()
    },
    contextmenu(item, index, event) {
      this.menuData = []
      event.preventDefault()
      if (!item.is_edit || !this.checkPermission(constants.EDIT_TEMPLATE_QUESTION)) {
        this.menuData = this.menuOptions.filter(val => val.id !== 1)
      } else {
        this.menuData = this.menuOptions
      }
      this.valuesContext = item
      this.$refs.templateContextMenu.open(event, item)
    },
    optionClicked(id) {
      if (id === 1) {
        this.$bvModal.show('createQuesitonModal')
      } else if (id === 2) {
        this.$bvModal.show('createQuesitonModal')
      }
    },

    changeStatus(status, id) {
      // eslint-disable-next-line eqeqeq
      if (status == 'A') {
        this.$swal({
          title: this.$i18n.t('Are you sure ?'),
          text: this.$i18n.t('You want to Deactivate this Question!'),
          icon: 'warning',
          showCancelButton: true,
          cancelButtonText: this.$i18n.t('Cancel'),
          confirmButtonText: this.$i18n.t('Yes'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            this.deactivateQuestion(id)
          }
        })
      } else {
        this.$swal({
          title: this.$i18n.t('Are you sure ?'),
          text: this.$i18n.t('You want to Activate this Question!'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$i18n.t('Yes'),
          cancelButtonText: this.$i18n.t('Cancel'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            this.activateQuestion(id)
          }
        })
      }
    },
    async deactivateQuestion(id) {
      showLoader()
      await store.dispatch('questionsStore/changeStatusQuestion', { status: 'I', template_question_id: id }).then(response => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == constants.SUCCESS) {
          this.getQuestionList()
          this.$swal({
            icon: 'success',
            title: this.$i18n.t('Success'),
            text: this.$i18n.t('Question is successfully Deactivated'),
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          hideLoader()
        }
      })
      hideLoader()
    },
    async activateQuestion(id) {
      showLoader()
      await store.dispatch('questionsStore/changeStatusQuestion', { status: 'A', template_question_id: id }).then(response => {
        // eslint-disable-next-line eqeqeq
        if (response.data.code == constants.SUCCESS) {
          this.getQuestionList()
          this.$swal({
            icon: 'success',
            title: this.$i18n.t('Success'),
            text: this.$i18n.t('Question is successfully Activated'),
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          hideLoader()
        }
      })
      hideLoader()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-context.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
